


















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { RootGettersReturns, User } from '@/store/types';
import { RaiseHand } from '@/utils/shouts';
import { Shout } from '@/store/types/stageState';

@Component({
  filters: {
    dateToTime: (val: string) => {
      return `${`${new Date(val).getHours()}`.padStart(2, '0')}:${`${new Date(val).getMinutes()}`.padStart(2, '0')}`;
    },
  },
})
export default class ShoutBox extends Vue {
  @Prop(Boolean) display!: boolean;
  @Getter shouts!: RootGettersReturns['shouts'];
  @Getter currentUser!: RootGettersReturns['currentUser'];
  @Getter sessionUsers!: RootGettersReturns['sessionUsers'];

  scrolledTo: null | number = null;

  @Watch('shouts')
  async scrollToBottom() {
    await this.$nextTick();
    await this.$nextTick();
    const wrapper = this.$refs.wrapper as HTMLElement;
    if (!Number.isInteger(this.scrolledTo as number) && wrapper) {
      wrapper.scrollTop = Number.MAX_SAFE_INTEGER;
    }
  }

  @Watch('display')
  async updateDisplay(val: boolean) {
    if (val) {
      await this.$nextTick();
      this.scrollToBottom();
    }
  }

  async mounted() {
    await this.$nextTick();
    this.scrollToBottom();
  }

  messageText(shout: Shout) {
    if (!RaiseHand.isShoutRaiseHand(shout)) {
      return shout.message;
    } else {
      const raised = RaiseHand.isRaisedHand(shout);
      return raised ? 'Raised hand!' : 'Lowered hand!';
    }
  }

  messageColor(shout: Shout) {
    if (!RaiseHand.isShoutRaiseHand(shout)) {
      return false;
    } else {
      const raised = RaiseHand.isRaisedHand(shout);
      return raised ? 'green--text' : 'primary--text';
    }
  }

  onScroll({ target }: { target: HTMLElement }) {
    if (target) {
      const currentScrollTop = target.scrollTop;
      const maxScrollTop = target.scrollHeight - target.offsetHeight;
      if (currentScrollTop != maxScrollTop) {
        this.scrolledTo = currentScrollTop;
      } else {
        this.scrolledTo = null;
      }
    }
  }

  userColor(id: number) {
    const user = this.sessionUsers.find(user => user.id === id);
    if (user) {
      return user.colorCode;
    } else {
      return 'currentColor';
    }
  }

  getUserName(user: User) {
    if (!this.currentUser) return '';
    return user.id === this.currentUser.id ? 'You' : user.fullName;
  }
}
